import React from 'react';
import styled from 'styled-components';
import { Parallax } from 'react-scroll-parallax';
import media from 'src/styles/media';

import Stop from './elements/Stop';
import imgSkytrain from 'src/assets/images/train.svg';
import imgTransitStart from 'src/assets/images/transit-t.svg';
import imgTransitEnd from 'src/assets/images/transit-end.svg';

const Stops = [
  {
    time: '25 Mins',
    name: 'Downtown Vancouver',
    large: true,
  },
  {
    time: '20 Mins',
    name: 'Commercial Drive',
  },
  {
    time: '11 Mins',
    name: 'Surrey City Centre',
    large: true,
  },
  {
    time: '11 Mins',
    name: 'Simon Fraser University, Surrey Campus',
    large: true,
  },
  {
    time: '10 Mins',
    name: 'Metrotown Shopping Centre',
    large: true,
  },
];

const Transit = () => (
  <Root>
    <Line>
      <img src={imgTransitStart} alt="Transit Start" />
      {Stops.map((stop, index) => (
        <Stop
          key={index}
          time={stop.time}
          name={stop.name}
          large={stop.large}
        />
      ))}
      <img src={imgTransitEnd} alt="Transit End" />
    </Line>
    <Parallax
      offsetXMax={0}
      offsetXMin={80}
      offsetYMin={'70px'}
      offsetYMax={'70px'}
      slowerScrollRate
    >
      <Skytrain src={imgSkytrain} alt="Skytrain" />
    </Parallax>
  </Root>
);

export default Transit;

const Root = styled.div`
  width: 100%;
  margin: 0 auto;
  background-color: #eaeaec;
  padding: 45px 0;
  text-align: center;
  position: relative;
  @media (min-width: ${media.mdup}) {
    z-index: 250;
  }
`;

const Line = styled.div`
  width: 90%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1;
  @media (min-width: ${media.mdup}) {
    flex-direction: row;
    width: 83.3%;
  }
  img {
    width: 64px;
  }
  &::after {
    content: '';
    border: 1px solid ${({ theme }) => theme.colorTransitBlue};
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: -1;
    @media (min-width: ${media.mdup}) {
      left: 0;
      right: 0;
      top: inherit;
      bottom: inherit;
    }
  }
`;

const Skytrain = styled.img`
  position: absolute;
  bottom: 25px;
  left: 5%;
`;



// WEBPACK FOOTER //
// ./src/components/Transit/Transit.js